import React from "react";

const ANIMATIONS_ENABLED_DEFAULT_VALUE = true;

const LottieAnimationsEnabledContext = React.createContext(
  ANIMATIONS_ENABLED_DEFAULT_VALUE,
);

export default LottieAnimationsEnabledContext;
